export * from './claim';
export * from './contract';
export * from './insuranceConfirmation';
export * from './party';
export * from './registrationBusinessCase';
export * from './userContactHistory';
/**
 * Those are abritary index names that will be mapped to their
 * respective real index names via env vars in elasticsearch in dataservice
 */
export const searchIndices = [
    'party',
    'contract',
    'claim',
    'log',
    'postalcode',
    'postbox',
    'location',
    'street',
    'event',
    'insurance-confirmation',
    'kkh',
    'registration-business-case',
];
/**
 * @deprecated
 * this is only here for interim compatibility
 */
export var SearchIndexLegacy;
(function (SearchIndexLegacy) {
    SearchIndexLegacy[SearchIndexLegacy["PARTY"] = 0] = "PARTY";
    SearchIndexLegacy[SearchIndexLegacy["CONTRACT"] = 1] = "CONTRACT";
    SearchIndexLegacy[SearchIndexLegacy["CLAIM"] = 2] = "CLAIM";
    SearchIndexLegacy[SearchIndexLegacy["LOG"] = 3] = "LOG";
    SearchIndexLegacy[SearchIndexLegacy["POSTALCODE"] = 4] = "POSTALCODE";
    SearchIndexLegacy[SearchIndexLegacy["POSTBOX"] = 5] = "POSTBOX";
    SearchIndexLegacy[SearchIndexLegacy["LOCATION"] = 6] = "LOCATION";
    SearchIndexLegacy[SearchIndexLegacy["STREET"] = 7] = "STREET";
    SearchIndexLegacy[SearchIndexLegacy["EVENT"] = 8] = "EVENT";
})(SearchIndexLegacy || (SearchIndexLegacy = {}));
